import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import DrawDetails from '@/components/DrawDetails';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/draw-details',
      name: 'drawDetails',
      component: DrawDetails,
    },
    {
      path: '/results',
      name: 'TerminalResults',
      component: () => import(/* webpackChunkName: "TerminalResults" */ '@/pages/TerminalResults'),
    },
    {
      path: '/ticket-details',
      name: 'TerminalTicketDetails',
      component: () => import(/* webpackChunkName: "TerminalTicketDetails" */ '@/pages/TicketCheck'),
    },
    {
      path: '/ticket-history',
      name: 'TerminalTicketHistory',
      component: () => import(/* webpackChunkName: "TerminalTicketHistory" */ '@/pages/TerminalTicketHistory'),
    },
  ],
});
